import { useEffect /*, useState*/, useState } from 'react';

import { ReactComponent as CloseIcon } from 'assets/icons/close-gray.svg';
import { useCookies } from 'react-cookie';
import {
  SaveButton,
  CloseButton,
  Content,
  Header,
  HeaderTitle,
  Modal,
  StyledFormGroup,
  StyledFormRadio,
  TransparentBg,
  StyledSelect,
} from './styled';

import { GrayLoading } from 'components/Loading/GrayLoading';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { Textarea } from 'components/Form/subcomponents/Textarea';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { ChamadoService } from 'services/main/endpoints/ChamadoService';
import { createGenericErrorToast, createSuccessToast } from 'utils/createToast';
import * as Sentry from '@sentry/react';
import { useMediaQuery } from 'react-responsive';
export const AuthorizeModal = ({ setToastList, data, setAuthorizeModalIsopen, updateTable }) => {
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(true);
  const cookie = useCookies()[0];
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      status: null,
      description: '',
      rate: '',
    },
  });
  const authorizeOcurrence = async values => {
    try {
      Sentry.captureMessage('Salvar Autorização', {
        tags: { Empresa: cookie.companies?.id },
      });
      const EmpresaId = cookie.companies?.id;
      const userId = cookie.chamadosAccess.userId;
      const formattedData = {
        anomaliaId: data?.anomaliaGid,
        statusAutorizacaoId: status.find(item => item.value === values?.status)?.realValue,
        descricao: values?.description,
        usuarioId: userId,
        plataforma: 6,
      };
      const response = await ChamadoService.authorizeOcurrence({
        empresaId: EmpresaId,
        unidadeId: data?.unidade,
        data: formattedData,
      });
      if (response.data.message === 'Ocorrência autorizada com sucesso') {
        createSuccessToast(setToastList, 'Autorização realizada.');
        updateTable();
      }
    } catch (err) {
      console.error(err);
      createGenericErrorToast(setToastList);
      Sentry.captureException(err);
    } finally {
      setAuthorizeModalIsopen(false);
    }
  };
  useEffect(() => {
    const getCorrectionsTypes = async () => {
      try {
        setLoading(true);
        const empresaId = cookie.companies?.id;
        const unidadeId = data?.unidade;
        const response = await ChamadoService.getCorrectionsTypes({ empresaId, unidadeId });
        const result = response.data
          .filter(item => item.codigo === 6 || item.codigo === 14)
          .map(item => ({ realValue: item.codigo, label: item.nome, value: item.tipoAcaoCorretivaEmpresa }));
        setStatus(result);
      } catch (err) {
        console.error(err);
        Sentry.captureException(err);
        createGenericErrorToast(setToastList);
      } finally {
        setLoading(false);
      }
    };

    getCorrectionsTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isDesktop = useMediaQuery({ minWidth: 1081 });
  return (
    <TransparentBg>
      <Modal height={''}>
        {loading ? (
          <>
            {' '}
            <GrayLoading />
          </>
        ) : (
          <>
            <Header>
              <HeaderTitle>Autorizar</HeaderTitle>
              <CloseButton onClick={() => setAuthorizeModalIsopen(false)}>
                <CloseIcon />
              </CloseButton>
            </Header>
            <FormProvider {...{ control, handleSubmit, setValue, watch }}>
              <Content>
                <FieldRow marginTop={'24px'} />
                <StyledFormGroup label={'Você aprova o serviço?'} isRequired>
                  <FieldRow marginTop={'18px'} />
                  <StyledFormRadio>
                    <Controller
                      name="status"
                      control={control}
                      render={props => (
                        <StyledSelect
                          {...props}
                          size={isDesktop ? 'large' : 'medium'}
                          placeholder="Selecionar"
                          options={status}
                          error={!!errors.status}
                          isUnitSelected={false}
                          onChange={value => {
                            props.onChange(value);
                          }}
                        />
                      )}
                    />
                  </StyledFormRadio>
                </StyledFormGroup>
                <FieldRow marginTop={'24px'} />
                <StyledFormGroup label="Descrição">
                  <FieldRow marginTop="18px" />
                  <Controller
                    name="description"
                    defaultValue=""
                    control={control}
                    render={props => (
                      <Textarea
                        {...props}
                        size="custom"
                        placeholder="Escreva aqui o que ocorreu"
                        width="100%"
                        customStyle={{
                          padding: '12px',
                          resize: 'none',
                          overflow: 'scroll',
                          height: '120px',
                        }}
                      />
                    )}
                  />
                </StyledFormGroup>
                <FieldRow marginTop="24px" />
                <SaveButton onClick={handleSubmit(authorizeOcurrence)}>Salvar</SaveButton>
                <FieldRow marginTop="24px" />
              </Content>
            </FormProvider>
          </>
        )}
      </Modal>
    </TransparentBg>
  );
};
